(() => {
  let appliedSdk;
  let appliedConsent;

  const syncConsent = () => {
    const sdk = window.posthog;
    const privacy = window.Shopify?.customerPrivacy;
    if (!sdk?.opt_in_capturing || !privacy?.analyticsProcessingAllowed) return;

    let allowed = false;
    try {
      allowed = privacy.analyticsProcessingAllowed() === true;
    } catch {
      // An unavailable consent decision must not enable diagnostics.
    }
    if (appliedSdk === sdk && appliedConsent === allowed) return;
    if (allowed) sdk.opt_in_capturing();
    else sdk.opt_out_capturing();
    appliedSdk = sdk;
    appliedConsent = allowed;
  };

  document.addEventListener('visitorConsentCollected', syncConsent);
  // PixieHog and Shopify's privacy API can finish loading in either order.
  document.addEventListener('load', syncConsent, true);
  window.Shopify?.loadFeatures?.(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    error => { if (!error) syncConsent(); }
  );
  syncConsent();
})();
